import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { isEqual } from 'lodash-es';

import { withSnackbar } from 'notistack';
import * as contractsActions from '../../Services/Contracts/actions';
import * as systemActions from '../../Services/System/actions';
import SummaryBlock from './SummaryBlock';
import ControlledExpansionPanels from './ControlledExpansionPanels';
// import ActivateContractBlock from './ActivateContractBlock';
import { showAlerts } from '../Common/utils';
import { parseQuery } from '../../Utils/Utils';

import './EditContract.scss';

class EditContract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contract: {
        contractNumber: undefined,
      },
      quote: {
        quoteNumber: undefined,
      }
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let nextState = null;
    const prevContract = prevState.contract;
    const { contracts } = nextProps;
    if (typeof prevContract.id !== 'undefined' && contracts) {
      const nextContract = contracts[prevContract.id];
      if (nextContract && !isEqual(nextContract, prevContract)) {
        nextState = { contract: { id: prevContract.id, ...nextContract } };
      }
    }
    if (!isEqual(nextProps.loading, prevState.loading)) {
      nextState = { ...nextState, alerts: nextProps.alerts };
    }
    return nextState;
  }

  componentDidMount() {
    const { actions, location } = this.props;
    const queryParams = parseQuery(location.search)
    const [key, value] = Object.entries(queryParams)[0]

    if (key === 'contract_number') {
      this.setState({
        contract: {
          contractNumber: value,
        },
      });
      actions.fetchContract({ contractNumber: value });

    } else if (key ==='quote_number') {
      this.setState({
        quote: {
          quoteNumber: value,
        },
      });
      actions.fetchQuote({ quoteNumber: value });

    }
  }

  componentDidUpdate(prevProps) {
    const { alerts: prevAlerts, loading: prevLoading } = prevProps;
    const { alerts, loading, enqueueSnackbar, strings } = this.props;
    if (!isEqual(prevLoading, loading) && !isEqual(prevAlerts, alerts)) {
      showAlerts({ enqueueSnackbar, alerts, strings });
    }
  }

  render() {
    const { pageTitle, canonical, strings, i18n, loading, frequency, clauses, actions, contracts } = this.props;
    const { addContractDocument, deleteContractDocument, submitQuote, createNote, cryptologSign, cryptologCheck, updateDocumentRequestLine } =
      actions;
    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || 'Contract'}</title>
        <meta name="description" content={strings[pageTitle] || 'Contract'} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const contract = contracts[this.state.contract.contractNumber || this.state.quote.quoteNumber]
    return (

      <div className="coog-app contract">
        {helmet}
        <h1 className="md-title md-cell md-cell--12">
          {strings[pageTitle] || 'Contract'}
        </h1>
        <div className="md-body md-cell md-cell--12">
          {contract ? (
            <>
              <SummaryBlock
                contract={contract}
                i18n={i18n}
                strings={strings}
                contractStatus={contract.contractStatus}
                loading={loading}
              />
              <ControlledExpansionPanels
                contract={contract}
                i18n={i18n}
                strings={strings}
                contractStatus={contract.contractStatus}
                loading={loading}
                frequency={frequency}
                clauses={clauses}
                // hasMissingBlockerDocument={hasMissingBlockerDocument()}
                deleteContractDocument={deleteContractDocument}
                addContractDocument={addContractDocument}
                updateDocumentRequestLine={updateDocumentRequestLine}
                submitQuote={submitQuote}
                createNote={createNote}
                cryptologCheck={cryptologCheck}
                cryptologSign={cryptologSign}
              />
            </>
          ) : undefined}
        </div>
      </div>
    );
  }
}

EditContract.propTypes = {
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  i18n: PropTypes.shape({
    lang: PropTypes.string,
    dateFormat: PropTypes.string,
  }).isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  actions: PropTypes.shape({
    getRoute: PropTypes.func,
    fetchContract: PropTypes.func,
    fetchQuote: PropTypes.func,
    fetchFrequency: PropTypes.func,
    fetchContractEvents: PropTypes.func,
    fetchContractDocuments: PropTypes.func,
    fetchContractAttachments: PropTypes.func,
    fetchContractStatus: PropTypes.func,
    addContractDocument: PropTypes.func,
    updateDocumentRequestLine: PropTypes.func,
    deleteContractDocument: PropTypes.func,
    createNote: PropTypes.func,
    submitQuote: PropTypes.func,
    cryptologCheck: PropTypes.func,
    cryptologSign: PropTypes.func,
    fetchNotes: PropTypes.func,
    fetchClauses: PropTypes.func,
  }),
  loading: PropTypes.object, // eslint-disable-line
  location: PropTypes.object.isRequired,
  contracts: PropTypes.object, // eslint-disable-line
  contractStatus: PropTypes.object, // eslint-disable-line
  frequency: PropTypes.object, // eslint-disable-line
  clauses: PropTypes.array, // eslint-disable-line
  alerts: PropTypes.object, // eslint-disable-line
  enqueueSnackbar: PropTypes.func.isRequired, // eslint-disable-line
};

EditContract.defaultProps = {
  pageTitle: 'title.contract.list',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  actions: {
    getRoute: () => {},
    fetchContract: () => {},
    fetchQuote: () => {},
    fetchFrequency: () => {},
    fetchContractEvents: () => {},
    fetchContractDocuments: () => {},
    fetchContractAttachments: () => {},
    fetchContractStatus: () => {},
    addContractDocument: () => {},
    updateDocumentRequestLine: () => {},
    deleteContractDocument: () => {},
    // eslint-disable-next-line no-console
    createNote: (...params) => console.log(`submitQuote:: ${params}`),
    // eslint-disable-next-line no-console
    submitQuote: (...params) => console.log(`submitQuote:: ${params}`),
    cryptologCheck: () => {},
    cryptologSign: () => {},
    fetchNotes: () => {},
    fetchClauses: () => {},
  },
  contracts: {},
  contractStatus: {},
  frequency: {},
  clauses: [],
  alerts: {},
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
  i18n: state.toJS().system.i18n,
  strings: state.toJS().contracts.strings,
  contracts: state.get('contracts').toJS().contracts,
  contractStatus: state.get('contracts').toJS().contractStatus,
  loading: state.get('contracts').toJS().loading,
  frequency: state.get('system').toJS().frequency,
  clauses: state.get('system').toJS().clauses,
  alerts: state.getIn(['contracts', 'alerts']),
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...contractsActions, ...systemActions }, dispatch),
});

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(EditContract)));
